import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class OrdersService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.PubNub = null;
    this.unsortedChannelList = [];
    this.nestedChannelList = [];
    this.arrayOfImageUrlsForGallery = [];
    this.controlChannelVal = null;

    //URLS
    this.get_actionable_deliveries = "actionable_deliveries";
  }

  getOrders(data) {
    console.log("what is the env");
    console.dir(this.$env);
    console.dir(data);
    let url = this.$env.EnvironmentConfig.ezcaterKey.url + this.get_actionable_deliveries;
    let req = {
      method: "JSONP",
      url: url,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: "Basic " + data.auth,
      },
      data: {},
    };

    console.log("what is the request");
    console.dir(req);
    return this.$http(req);
  }
}

OrdersService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout"];



// WEBPACK FOOTER //
// ./client/app/services/orders.js